import { Component, OnInit,ElementRef,ViewChild } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { Platform, NavController } from '@ionic/angular';
import { MapclientServiceService } from '../../../../service/mapclient.service.service';
import { MessageclientService } from '../../../../service/messageclient.service';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import {BaseModal} from '../../../../model/base';
import {WebParameterContext} from '../../../../model/common';
import { CommonService } from '../../../../service/common.service';
import { GridBaseCase } from '../../../components/grid/grid.base.case';
declare var app;


@Component({
  selector: 'app-list-detail',
  templateUrl: './list-detail.component.html',
  styleUrls: ['./list-detail.component.scss']
})
export class ListDetailComponent extends GridBaseCase{
  productsInfo:any = null;
  productsName:string = "";
  constructor(
    private platform:Platform,
    private activaRouter: ActivatedRoute,
    private router:Router,
    private map:MapclientServiceService,
    private msg:MessageclientService,
    private http: HttpCustomerService,
    public base:BaseModal,
    public com:CommonService,
    private navctr:NavController,
  ) { super();}

  goBack(){
    this.com.goBack();
   
  }

  LoadData(PageNumber:any = 1) {
    let that = this;
    // console.log(that.PageNumber);
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    let body = new WebParameterContext();
    body.ConfigName = "TBProductInformationXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.RequestBody = JSON.stringify({"a_ID":id});
    that.http.post(app.DEFAULTURL, body).then(data => {
      that.apiObj['status'] = data.ResponseMessage.Success;
      that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      that.loading = true;
      if (data.ResponseMessage.Success) {
        that.productsInfo = data.Status.Datas;
        if(data.Status.Datas.length > 0){
          that.productsName = data.Status.Datas[0]["a_ProductName"];
        }
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }

}
